import { toCamelKeys } from '@dotone/react-ui-core';
import { NotificationApi } from '@api';
import { notificationTypes as actionTypes } from './types';

export const fetchNotifications = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.LIST.LOADING,
  });

  NotificationApi.getList(params)
    .then((response) => {
      dispatch({
        type: actionTypes.LIST.SUCCESS,
        payload: response,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LIST.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};

export const fetchUnreadNotifications = (params) => (dispatch) => {
  dispatch({
    type: actionTypes.LIST_UNREAD.LOADING,
  });

  NotificationApi.getUnreadList(params)
    .then((response) => {
      dispatch({
        type: actionTypes.LIST_UNREAD.SUCCESS,
        payload: response,
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.LIST_UNREAD.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};

export const receiveNotification = (data) => (dispatch) => {
  const { notification, unread } = toCamelKeys(data) || {};

  if (!notification) {
    return;
  }

  dispatch({
    type: actionTypes.LIST_UNREAD.HYDRATE,
    payload: { data: notification, unread, status: 'success' },
    method: 'prepend',
  });

  dispatch({
    type: actionTypes.LIST.HYDRATE,
    payload: { data: notification, status: 'success' },
    method: 'prepend',
  });
};

export const readNotification = (id, params) => (dispatch, getState) => {
  dispatch({
    type: actionTypes.READ.LOADING,
  });

  NotificationApi.read(id, params)
    .then((response) => {
      dispatch({
        type: actionTypes.READ.SUCCESS,
        payload: response,
      });

      dispatch({
        type: actionTypes.LIST.HYDRATE,
        payload: response,
        method: 'add',
      });

      const { unread } = getState().notificationUnreadList;

      dispatch({
        type: actionTypes.LIST_UNREAD.HYDRATE,
        payload: { data: id, unread: Math.max(unread - 1, 0) },
        method: 'remove',
      });
    })
    .catch((error) => {
      dispatch({
        type: actionTypes.READ.FAILURE,
        message: `notify:general.errors.${error.status}`,
      });
    });
};
